import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { setJobtypes } from '../actions/jobtypes.actions';
import { Jobtype } from '../models/jobtype.model';
import { Consultant } from '../models/consultant.model';
import * as helpers from '../helpers/helpers';

export const initialState: Jobtype[] = [];

const reducer = createReducer(initialState,
  on(setJobtypes, (state, { jobtypes }) => jobtypes)
);

export const fromJobtypes = {
  selectJobtypesState: createFeatureSelector<Jobtype[]>('jobtypes'),

  selectBusinessJobtypes: createSelector(
    ((state: { jobtypes: Jobtype[], consultant: Consultant }) => state.jobtypes),
    ((state: { jobtypes: Jobtype[], consultant: Consultant }) => state.consultant),
    (jobtypes: Jobtype[], consultant: Consultant) => jobtypes.filter(jobtype =>
      jobtype.businessArea.some(area => helpers.getBusinessFromOffice(consultant.office).includes(area))
    ).sort((a, b) => helpers.alphabeticSort(a.name, b.name))
  ),
};

export function jobtypesReducer(state, action) {
  return reducer(state, action);
}
